import { useCallback } from 'react';

import { useAnalytics } from '@bonusly/who-am-i';

export interface CompleteClaimRewardEventProps {
	categories: string;
	giftEmail?: string;
	isGift?: 'Yes' | 'No';
	isGiftable?: 'Yes' | 'No';
	price: string;
	result: 'Success' | 'Failure';
	rewardName: string;
}
export interface ComfirmClaimRewardClickEventProps {
	categories: string;
	giftEmail?: string;
	isGift?: 'Yes' | 'No';
	isGiftable?: 'Yes' | 'No';
	price: string;
	rewardName: string;
}
export interface HomeRecommendedRewardClickEventProps {
	rewardName: string;
	categories: string;
	recommendedReason: 'promoted' | 'personal_recommendation' | '';
}

export interface RewardCategoryClickEventProps {
	categoryName: string;
}

export interface RewardNavigationEventProps {
	pathway: 'menu' | 'shop_reward_cta';
}

export interface RewardTileClickEventProps {
	categories: string;
	rewardName: string;
	previouslyClaimed: boolean;
}

export const useRewardAnalytics = () => {
	const { track } = useAnalytics();

	const trackCompleteClaimReward = useCallback(
		(eventProps: CompleteClaimRewardEventProps) => {
			track('Complete Claim Reward', {
				...eventProps,
			});
		},
		[track]
	);

	const trackConfirmClaimRewardClick = useCallback(
		(eventProps: ComfirmClaimRewardClickEventProps) => {
			track('Confirm Claim Reward Click', {
				...eventProps,
			});
		},
		[track]
	);

	const trackHomeRecommendedRewardClick = useCallback(
		(eventProps: HomeRecommendedRewardClickEventProps) => {
			track('Home Recommended Reward Click', {
				...eventProps,
			});
		},
		[track]
	);

	const trackRewardCategoryClick = useCallback(
		(eventProps: RewardCategoryClickEventProps) => {
			track('Reward Category Click', {
				...eventProps,
			});
		},
		[track]
	);

	const trackRewardHistoryClick = useCallback(() => {
		track('Reward History Click');
	}, [track]);

	const trackRewardNavigation = useCallback(
		(eventProps: RewardNavigationEventProps) => {
			track('Reward Navigation', {
				...eventProps,
			});
		},
		[track]
	);

	const trackRewardTileClick = useCallback(
		(eventProps: RewardTileClickEventProps) => {
			track('Reward Tile Click', {
				...eventProps,
			});
		},
		[track]
	);

	return {
		trackCompleteClaimReward,
		trackConfirmClaimRewardClick,
		trackHomeRecommendedRewardClick,
		trackRewardCategoryClick,
		trackRewardHistoryClick,
		trackRewardNavigation,
		trackRewardTileClick,
	};
};
